module.exports = __webpack_public_path__ + "static/media/gateway-html.6d361491.png";